<template>
  <div class="about-page">
    <!-- Page Header -->
    <section class="page-hero">
      <div class="container">
        <h1 class="hero-title">关于我们</h1>
        <p class="hero-subtitle">专注数字化解决方案，助力企业成功转型</p>
      </div>
    </section>

    <!-- Company Introduction -->
    <section class="company-intro">
      <div class="container">
        <div class="intro-layout">
          <div class="intro-content">
            <h2 class="section-title">雪顶科技</h2>
            <div class="company-tagline">
              <span class="tagline-text">让数字化更简单</span>
            </div>
            <p class="intro-description">
              河南雪顶信息技术有限公司成立于2018年，是一家专注于数字化解决方案的创新型科技公司。
              我们致力于为企业提供高效、稳定、易用的数字化产品和服务，
              帮助企业在数字化转型过程中提升竞争力，实现业务增长。
            </p>
            <p class="intro-description">
              公司核心团队拥有丰富的互联网和企业服务经验，
              在抖音、小红书生态、微短剧发行、IPTV技术、AI数字人、智能体开发等领域有着深入的理解和实践。
              我们相信技术的力量，更相信技术与业务的完美结合能够创造更大的价值。
            </p>
            
            <div class="company-stats">
              <div class="stat-item">
                <div class="stat-number">8</div>
                <div class="stat-label">年发展历程</div>
              </div>
              <div class="stat-item">
                <div class="stat-number">50+</div>
                <div class="stat-label">专业团队</div>
              </div>
              <div class="stat-item">
                <div class="stat-number">1000+</div>
                <div class="stat-label">服务客户</div>
              </div>
              <div class="stat-item">
                <div class="stat-number">10+</div>
                <div class="stat-label">核心产品</div>
              </div>
            </div>
          </div>
          
          <div class="intro-visual">
            <div class="company-image">
              <img src="../assets/company-introduce-img5.png" alt="雪钉科技办公环境">
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Company Culture -->
    <section class="company-culture">
      <div class="container">
        <h2 class="section-title">企业文化</h2>
        <p class="section-subtitle">我们的价值观指引着我们前进的方向</p>
        
        <div class="culture-grid">
          <div class="culture-card" v-for="culture in companyCulture" :key="culture.id">
            <div class="culture-icon">{{ culture.icon }}</div>
            <h3 class="culture-title">{{ culture.title }}</h3>
            <p class="culture-description">{{ culture.description }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Company Timeline -->
    <section class="company-timeline">
      <div class="container">
        <h2 class="section-title">发展历程</h2>
        <p class="section-subtitle">见证我们一步步成长的足迹</p>
        
        <div class="timeline">
          <div class="timeline-item" v-for="(milestone, index) in milestones" :key="milestone.id">
            <div class="timeline-marker">
              <div class="timeline-dot"></div>
              <div class="timeline-line" v-if="index < milestones.length - 1"></div>
            </div>
            <div class="timeline-content">
              <div class="timeline-date">{{ milestone.date }}</div>
              <h3 class="timeline-title">{{ milestone.title }}</h3>
              <p class="timeline-description">{{ milestone.description }}</p>
              <div class="timeline-achievements" v-if="milestone.achievements">
                <div class="achievement-tag" v-for="achievement in milestone.achievements" :key="achievement">
                  {{ achievement }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Team Section -->
    <!-- <section class="team-section">
      <div class="container">
        <h2 class="section-title">核心团队</h2>
        <p class="section-subtitle">经验丰富的专业团队，共同创造卓越</p>
        
        <div class="team-grid">
          <div class="team-member" v-for="member in teamMembers" :key="member.id">
            <div class="member-avatar">
              <img :src="member.avatar" :alt="member.name">
            </div>
            <div class="member-info">
              <h3 class="member-name">{{ member.name }}</h3>
              <p class="member-position">{{ member.position }}</p>
              <p class="member-description">{{ member.description }}</p>
              <div class="member-expertise">
                <span class="expertise-tag" v-for="skill in member.expertise" :key="skill">
                  {{ skill }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section> -->

    <!-- Contact Section -->
    <section class="contact-section">
      <div class="container">
        <h2 class="section-title">联系我们</h2>
        <p class="section-subtitle">期待与您的合作</p>
        
        <div class="contact-layout">
          <div class="contact-info">
            <div class="contact-item">
              <div class="contact-icon">🏢</div>
              <div class="contact-details">
                <h4>公司地址</h4>
                <p>河南自贸试验区开封片区郑开大道七大街绿地中部创客天地</p>
              </div>
            </div>
            
            <div class="contact-item">
              <div class="contact-icon">📞</div>
              <div class="contact-details">
                <h4>联系电话</h4>
                <p>400-688-5235</p>
                <p>17839217339</p>
              </div>
            </div>
            
            <div class="contact-item">
              <div class="contact-icon">📧</div>
              <div class="contact-details">
                <h4>邮箱地址</h4>
                <p>2294788755@qq.com</p>
                <!-- <p>hr@xueding.com</p> -->
              </div>
            </div>
            
            <!-- <div class="contact-item">
              <div class="contact-icon">💬</div>
              <div class="contact-details">
                <h4>社交媒体</h4>
                <p>微信：xueding-tech</p>
                <p>微博：@雪钉科技</p>
              </div>
            </div> -->
          </div>
          
          <div class="contact-form">
            <h3>发送消息</h3>
            <form @submit.prevent="submitMessage">
              <div class="form-group">
                <label>姓名</label>
                <input type="text" v-model="messageForm.name" required>
              </div>
              
              <div class="form-group">
                <label>邮箱</label>
                <input type="email" v-model="messageForm.email" required>
              </div>
              
              <div class="form-group">
                <label>主题</label>
                <input type="text" v-model="messageForm.subject" required>
              </div>
              
              <div class="form-group">
                <label>消息内容</label>
                <textarea v-model="messageForm.message" rows="5" required></textarea>
              </div>
              
              <button type="submit" class="submit-btn">发送消息</button>
            </form>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'AboutPage',
  data() {
    return {
      messageForm: {
        name: '',
        email: '',
        subject: '',
        message: ''
      },
      companyCulture: [
        {
          id: 1,
          icon: '🎯',
          title: '客户至上',
          description: '始终以客户需求为中心，提供超越期望的产品和服务'
        },
        {
          id: 2,
          icon: '🚀',
          title: '创新驱动',
          description: '持续技术创新，引领行业发展，为客户创造更大价值'
        },
        {
          id: 3,
          icon: '🤝',
          title: '合作共赢',
          description: '与客户、合作伙伴建立长期共赢的战略合作关系'
        },
        // {
        //   id: 4,
        //   icon: '💎',
        //   title: '追求卓越',
        //   description: '精益求精，持续改进，在每一个细节中体现专业品质'
        // }
      ],
      milestones: [
        {
          id: 1,
          date: '2018年',
          title: '公司成立',
          description: '雪顶科技正式成立，开始专注于微信生态数字化解决方案的研发',
          achievements: ['核心团队组建', '初期产品规划', '种子轮融资']
        },
        {
          id: 2,
          date: '2022年',
          title: '业务拓展',
          description: '推出微短剧SAAS系统，业务线进一步丰富',
          achievements: ['新产品发布', '团队规模扩大', '行业领先地位']
        },
        {
          id: 3,
          date: '2024年',
          title: '产品研发',
          description: '完成首款产品小红书团购SAAS系统的开发，获得市场认可',
          achievements: ['产品正式上线', '获得100+客户', '持续创新']
        },
        {
          id: 4,
          date: '2025年',
          title: '生态完善',
          description: 'IPTV C2分发系统上线，形成完整的数字化产品生态',
          achievements: ['产品矩阵完善', '全国渠道布局', '技术专利申请']
        },
        {
          id: 5,
          date: '2025年',
          title: '持续创新',
          description: '继续深耕产品技术，拓展新的业务领域和合作机会',
          achievements: ['AI技术融合', '国际市场拓展', '战略合作升级']
        }
      ],
      teamMembers: [
        {
          id: 1,
          name: '张建华',
          position: 'CEO & 创始人',
          description: '15年互联网行业经验，曾任职于知名互联网公司，在产品策划和商业模式创新方面有着丰富经验。',
          avatar: 'https://picsum.photos/150/150?random=80',
          expertise: ['战略规划', '商业模式', '团队管理', '融资并购']
        },
        {
          id: 2,
          name: '李明杰',
          position: 'CTO & 联合创始人',
          description: '12年技术研发经验，技术架构专家，在大规模系统设计和技术团队管理方面经验丰富。',
          avatar: 'https://picsum.photos/150/150?random=81',
          expertise: ['技术架构', '系统设计', '团队管理', '技术创新']
        },
        {
          id: 3,
          name: '王晓丽',
          position: '产品总监',
          description: '8年产品经验，在小红书生态和内容分发领域有深入研究，负责公司产品战略和规划。',
          avatar: 'https://picsum.photos/150/150?random=82',
          expertise: ['产品策略', '用户体验', '市场分析', '需求分析']
        }
      ]
    }
  },
  methods: {
    submitMessage() {
      if (this.validateMessageForm()) {
        alert('消息发送成功！我们会尽快回复您')
        this.resetMessageForm()
      }
    },
    validateMessageForm() {
      const { name, email, subject, message } = this.messageForm
      if (!name || !email || !subject || !message) {
        alert('请填写所有必填项')
        return false
      }
      return true
    },
    resetMessageForm() {
      this.messageForm = {
        name: '',
        email: '',
        subject: '',
        message: ''
      }
    }
  }
}
</script>

<style scoped>
.about-page {
  padding-top: 70px;
  min-height: 100vh;
}

.page-hero {
  background: linear-gradient(135deg, #3470ff 0%, #764ba2 100%);
  color: white;
  padding: 80px 0;
  text-align: center;
}

.hero-title {
  font-size: 3rem;
  font-weight: bold;
  margin-bottom: 20px;
}

.hero-subtitle {
  font-size: 1.3rem;
  opacity: 0.9;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.section-title {
  font-size: 2.5rem;
  font-weight: bold;
  text-align: center;
  margin-bottom: 20px;
  color: #2c3e50;
}

.section-subtitle {
  font-size: 1.2rem;
  text-align: center;
  color: #666;
  margin-bottom: 60px;
  line-height: 1.6;
}

.company-intro {
  padding: 80px 0;
}

.intro-layout {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 80px;
  align-items: center;
}

.company-tagline {
  margin-bottom: 30px;
}

.tagline-text {
  background: linear-gradient(135deg, #3470ff, #667eea);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-size: 1.5rem;
  font-weight: bold;
}

.intro-description {
  font-size: 1.1rem;
  line-height: 1.8;
  color: #555;
  margin-bottom: 20px;
}

.company-stats {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;
  margin-top: 40px;
}

.stat-item {
  text-align: center;
}

.stat-number {
  font-size: 2.5rem;
  font-weight: bold;
  color: #3470ff;
  margin-bottom: 10px;
}

.stat-label {
  font-size: 1rem;
  color: #666;
}

.intro-visual {
  text-align: center;
}

.company-image img {
  width: 100%;
  max-width: 500px;
  border-radius: 20px;
  box-shadow: 0 20px 40px rgba(0,0,0,0.1);
  transition: all 0.3s ease;
}

.company-image img:hover {
  transform: translateY(-10px);
  box-shadow: 0 30px 60px rgba(0,0,0,0.15);
}

.company-culture {
  padding: 80px 0;
  background: #f8f9fa;
}

.culture-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 30px;
}

.culture-card {
  background: white;
  padding: 40px 30px;
  border-radius: 20px;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0,0,0,0.05);
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

.culture-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 20px 40px rgba(0,0,0,0.1);
  border-color: #3470ff;
}

.culture-icon {
  font-size: 3rem;
  margin-bottom: 20px;
}

.culture-title {
  font-size: 1.3rem;
  font-weight: bold;
  color: #2c3e50;
  margin-bottom: 15px;
}

.culture-description {
  color: #666;
  line-height: 1.6;
}

.company-timeline {
  padding: 80px 0;
}

.timeline {
  max-width: 700px;
  margin: 0 auto;
  /* margin-left: 100px; */
  position: relative;
}

.timeline-item {
  display: flex;
  margin-bottom: 60px;
  position: relative;
}

.timeline-marker {
  position: relative;
  width: 20px;
  height: 20px;
  margin-right: 30px;
  flex-shrink: 0;
}

.timeline-dot {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #3470ff;
  position: relative;
  z-index: 2;
}

.timeline-line {
  position: absolute;
  top: 20px;
  left: 50%;
  width: 2px;
  height: 60px;
  background: #e9ecef;
  transform: translateX(-50%);
}

.timeline-content {
  flex: 1;
}

.timeline-date {
  color: #3470ff;
  font-weight: bold;
  font-size: 1.1rem;
  margin-bottom: 10px;
}

.timeline-title {
  font-size: 1.4rem;
  font-weight: bold;
  color: #2c3e50;
  margin-bottom: 10px;
}

.timeline-description {
  color: #666;
  line-height: 1.6;
  margin-bottom: 15px;
}

.timeline-achievements {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.achievement-tag {
  background: linear-gradient(135deg, #3470ff, #667eea);
  color: white;
  padding: 5px 15px;
  border-radius: 20px;
  font-size: 0.9rem;
  font-weight: 500;
}

.team-section {
  padding: 80px 0;
  background: #f8f9fa;
}

.team-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 40px;
}

.team-member {
  background: white;
  padding: 30px;
  border-radius: 20px;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0,0,0,0.05);
  transition: all 0.3s ease;
}

.team-member:hover {
  transform: translateY(-5px);
  box-shadow: 0 20px 40px rgba(0,0,0,0.1);
}

.member-avatar {
  margin-bottom: 20px;
}

.member-avatar img {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  object-fit: cover;
  border: 4px solid #3470ff;
}

.member-name {
  font-size: 1.3rem;
  font-weight: bold;
  color: #2c3e50;
  margin-bottom: 5px;
}

.member-position {
  color: #3470ff;
  font-weight: 600;
  margin-bottom: 15px;
}

.member-description {
  color: #666;
  line-height: 1.6;
  margin-bottom: 20px;
  font-size: 0.95rem;
}

.member-expertise {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
}

.expertise-tag {
  background: #f1f3f4;
  color: #555;
  padding: 4px 12px;
  border-radius: 15px;
  font-size: 0.85rem;
}

.contact-section {
  padding: 80px 0;
}

.contact-layout {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: start;
}

.contact-info {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.contact-item {
  display: flex;
  align-items: flex-start;
  gap: 20px;
}

.contact-icon {
  font-size: 2rem;
  width: 50px;
  text-align: center;
}

.contact-details h4 {
  font-size: 1.1rem;
  font-weight: bold;
  color: #2c3e50;
  margin-bottom: 8px;
}

.contact-details p {
  color: #666;
  margin-bottom: 5px;
}

.contact-form {
  background: white;
  padding: 40px;
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.05);
}

.contact-form h3 {
  font-size: 1.5rem;
  font-weight: bold;
  color: #2c3e50;
  margin-bottom: 30px;
  text-align: center;
}

.form-group {
  margin-bottom: 25px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  color: #2c3e50;
}

.form-group input,
.form-group textarea {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #e9ecef;
  border-radius: 10px;
  font-size: 1rem;
  transition: all 0.3s ease;
  font-family: inherit;
}

.form-group input:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #3470ff;
  box-shadow: 0 0 0 3px rgba(52, 112, 255, 0.1);
}

.submit-btn {
  width: 100%;
  background: linear-gradient(135deg, #3470ff, #667eea);
  color: white;
  border: none;
  padding: 15px 30px;
  border-radius: 10px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.submit-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 20px rgba(52, 112, 255, 0.3);
}

@media (max-width: 768px) {
  .intro-layout,
  .contact-layout {
    grid-template-columns: 1fr;
    gap: 40px;
  }
  
  .company-stats {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .hero-title {
    font-size: 2rem;
  }
  
  .section-title {
    font-size: 2rem;
  }
}
</style> 
